import { BreakpointObserver } from '@angular/cdk/layout';
import { inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { map } from 'rxjs';

export const windowSizeClassesSignalFactory = (classes: string | string[]) => {
  const breakpointObserver = inject(BreakpointObserver);

  return toSignal(
    breakpointObserver
      .observe(classes)
      .pipe(map((state) => state.matches)),
    { requireSync: true }
  );
};
